<template>
  <Modal :is-open="isOpen" @close="$emit('close')">
    <template #title>Add a customer</template>
    <template #body>
      <div class="flex flex-col gap-4">
        <label class="flex flex-col gap-1 text-sm font-medium">
          Name
          <input
            v-model="name"
            type="text"
            placeholder="Customer name"
            class="border border-gray-brand-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
          />
        </label>
        <label class="flex flex-col gap-1 text-sm font-medium">
          Phone number
          <input
            v-model="phone"
            type="tel"
            placeholder="(555) 555-5555"
            class="border border-gray-brand-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
          />
        </label>
        <p v-if="error" class="text-sm text-red-600">{{ error }}</p>
        <p class="text-xs text-gray-brand-500">
          If this phone number is already a customer of this store and unassigned, they will be added to your customers.
        </p>
      </div>
    </template>
    <template #footer>
      <PrimaryButton size="lg" :isLoading="saving" :active="phoneIsValid" @click="submit">Add customer</PrimaryButton>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Molecules/Modal'
import PrimaryButton from '@/components/Molecules/PrimaryButton'
import merchantFetch from '@/utils/merchantFetch'

export default {
  name: 'AddCustomerModal',
  components: { Modal, PrimaryButton },
  props: {
    isOpen: { type: Boolean, default: false }
  },
  emits: ['close', 'added'],
  data() {
    return { name: '', phone: '', saving: false, error: null }
  },
  computed: {
    phoneIsValid() {
      return this.phone.replace(/\D/g, '').length >= 10
    }
  },
  watch: {
    isOpen(open) {
      if (open) {
        this.name = ''
        this.phone = ''
        this.error = null
      }
    }
  },
  methods: {
    async submit() {
      if (!this.phoneIsValid || this.saving) return
      this.saving = true
      this.error = null
      try {
        await merchantFetch('reseller/customers', {
          method: 'POST',
          body: JSON.stringify({ name: this.name, phone: this.phone.replace(/\D/g, '') })
        })
        this.$emit('added')
      } catch (e) {
        this.error =
          e.message === '422'
            ? 'This customer already belongs to another reseller. Ask the store owner to reassign them.'
            : 'Something went wrong. Please try again.'
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
